import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  span {
    font-size: 18px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  hr {
    border: 1px solid ${({ theme }) => theme.colors.neutral.white};
    width: 100%;
  }
`;

export const Messages = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  width: 100%;

  padding: 10px;
  background-color: ${({ theme }) => theme.colors.neutral.cinza900};

  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;

  margin-bottom: 20px;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const File = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  width: 100%;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 10px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  width: 100%;

  margin-bottom: 20px;

  span {
    font-size: 16px;
  }
`;

export const Message = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;

  position: relative;

  justify-self: ${({ isOwn }) => (isOwn ? "flex-end" : "flex-start")};

  width: fit-content;
  min-width: 200px;
  max-width: 80%;

  padding: 10px;

  border: ${({ theme, isOwn }) =>
    isOwn ? "none" : `2px solid ${theme.colors.neutral.white}`};

  background-color: ${({ theme, isOwn }) =>
    isOwn ? `${theme.colors.neutral.cinza600};` : "none"};

  opacity: ${({ active }) => (active ? 1 : 0.5)};
`;

export const MessageStatus = styled.span`
  font-size: 14px;
  font-weight: 700;

  display: ${({ status }) => (status === "Aprovada" ? "none" : "block")};

  color: ${({ theme, status }) => {
    switch (status) {
      case "Aprovada":
        return theme.colors.neutral.cinza600;
      case "Rejeitada":
        return theme.colors.feedbackState.critical.default;
      default:
        return theme.colors.feedbackState.warning.default;
    }
  }};
`;

export const MessageInfos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  width: 100%;

  h2 {
    font-size: 16px;
  }

  span {
    font-size: 14px;
  }
`;

export const MessageFile = styled.a`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.white};
  font-weight: 700;

  text-decoration: underline;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.neutral.white};
    font-weight: 700;
  }

  p {
    color: ${({ theme }) => theme.colors.neutral.cinza600};
  }
`;
